import { motion } from "framer-motion"
import { useState } from "react"
import SkyAngelLogo from "../../img/SkyAngel.png"

export default function FooterGeneral() {
  const [isHovered, setIsHovered] = useState(false)


  const textVariants = {
    hover: { y: -5, transition: { duration: 0.3 } },
    initial: { y: 0 },
  }

  return (
    <motion.footer
      className="bg-gradient-to-r from-customCyan to-customBlue text-white px-6 shadow-lg" 
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container mx-auto flex flex-wrap justify-between items-center">
        <motion.div
          className="flex items-center space-x-4"
          onHoverStart={() => setIsHovered(true)}
          onHoverEnd={() => setIsHovered(false)}
        >
          <motion.div animate={isHovered ? "hover" : "initial"}>
            <a href="https://skyangel.com.mx/" className="block mt-4">
              <img
                src={SkyAngelLogo}
                width={50}
                height={50}
                alt="SkyAngel Logo"
              />
            </a>
          </motion.div>
          <motion.span
            className="text-sm md:text-base"
            variants={textVariants}
            animate={isHovered ? "hover" : "initial"}
          >
            Copyright © {new Date().getFullYear()} Skyangel
          </motion.span>
        </motion.div>
        <motion.div
          className="mt-4 md:mt-0"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          <p className="text-sm md:text-base text-right">
            Esta es la página electrónica de SkyClear de la empresa SkyAngel.
          </p>
        </motion.div>
      </div>
      <motion.div
        className="w-full h-1 bg-white mt-6"
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ delay: 0.5, duration: 0.5 }}
      />
    </motion.footer>
  )
}